<button class="btn btn-success"
        [routerLink]="['add']">
  <fa-icon [icon]="['fas', 'plus']"></fa-icon>
</button>